export const ShareFacebookSVG = (props) => (
  <svg height={33} viewBox="0 0 32 33" width={32} {...props}>
    <path
      d="m15.9674286.06647619c-8.81847622 0-15.9674286 7.14895238-15.9674286 15.96742861 0 7.9091428 5.75657143 14.4592381 13.304381 15.727619v-12.3963809h-3.85180957v-4.4609524h3.85180957v-3.2893334c0-3.81657139 2.3310476-5.89638091 5.7361904-5.89638091 1.6308572 0 3.032381.12152381 3.4392381.17504762v3.98933333l-2.3617143.00114286c-1.8514285 0-2.2083809.879619-2.2083809 2.1708571v2.8470477h4.4177143l-.5761905 4.4609523h-3.8415238v12.5053334c7.9001905-.9615238 14.0249524-7.6784762 14.0249524-15.8388572 0-8.81390473-7.1489524-15.96285711-15.9672381-15.96285711z"
      fill="#010002"
      transform="translate(0 .5)"
    />
  </svg>
);

export const SharePinterestSVG = (props) => (
  <svg height={33} viewBox="0 0 32 33" width={32} {...props}>
    <filter id="a">
      <feColorMatrix
        in="SourceGraphic"
        type="matrix"
        values="0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 1.000000 0"
      />
    </filter>
    <g
      fill="none"
      fillRule="evenodd"
      filter="url(#a)"
      transform="translate(0 .5)"
    >
      <path
        d="m15.9963197 0c-8.81035479 0-15.96881093 7.15845614-15.96881093 15.9688109 0 6.5527018 3.90961404 12.1693567 9.58128655 14.6472671-.05507992-1.1012866 0-2.4779104.27533723-3.6893568.33041715-1.3215438 2.03739575-8.7002573 2.03739575-8.7002573s-.4955946-1.0462066-.4955946-2.5329902c0-2.3678129 1.3766238-4.1298714 3.0836024-4.1298714 1.4317037 0 2.1475555 1.1012866 2.1475555 2.4228304 0 1.4317038-.9361091 3.6342769-1.4317037 5.6716726-.3854347 1.7070409.8259493 3.0836023 2.5329903 3.0836023 3.0285848 0 5.0659805-3.909614 5.0659805-8.48 0-3.5241793-2.3678129-6.11218713-6.6628616-6.11218713-4.8457232 0-7.87424564 3.63427683-7.87424564 7.65398833 0 1.3766238.3854347 2.3678128 1.04620663 3.1386822.27533723.3304172.33041715.4955946.22025731.8810293-.05507992.2753372-.27533723.9911891-.33041715 1.2664639-.11015985.3854347-.44051462.5506745-.82594932.3854347-2.25765302-.9361092-3.24884211-3.3589396-3.24884211-6.1121871 0-4.5153061 3.79945419-9.96672127 11.39842498-9.96672127 6.1121871 0 10.131961 4.40520857 10.131961 9.14077197 0 6.2773645-3.4690994 10.9579103-8.5900975 10.9579103-1.7070409 0-3.3589395-.9361092-3.909614-1.9823158 0 0-.9361092 3.6893567-1.1012866 4.4052086-.3304171 1.2114464-.991189 2.4779103-1.5968811 3.4140195 1.4317037.4405146 2.9735049.6607719 4.5153061.6607719 8.8103548 0 15.9688109-7.1584561 15.9688109-15.9688109 0-8.81035479-7.1583938-16.0237661-15.9688109-16.0237661"
        fill="#000"
        fillRule="nonzero"
      />
    </g>
  </svg>
);

export const ShareTwitterSVG = (props) => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="black"/>
    <path d="M6.1439 6.73047L13.7917 16.9561L6.0957 25.2701H7.8279L14.5659 17.9909L20.0098 25.2701H25.9042L17.8259 14.4694L24.9893 6.73047H23.2572L17.052 13.4342L12.0382 6.73047H6.1439ZM8.69118 8.00627H11.399L23.3565 23.9943H20.6487L8.69118 8.00627Z" fill="white"/>
  </svg>
);

export const ShareWhatsappSVG = (props) => (
  <svg height={32} viewBox="0 0 32 32" width={32} {...props}>
    <filter id="a" colorInterpolationFilters="auto">
      <feColorMatrix
        in="SourceGraphic"
        type="matrix"
        values="0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 1.000000 0"
      />
    </filter>
    <g
      fill="none"
      fillRule="evenodd"
      filter="url(#a)"
      transform="translate(-188 -19)"
    >
      <path
        d="m16.2901429 0c-8.67550004 0-15.7091429 6.97864286-15.7091429 15.588 0 2.945.82371429 5.6992857 2.25421429 8.0490714l-2.83521429 8.3629286 8.69742857-2.763c2.25057143 1.2346429 4.83892853 1.939 7.59271433 1.939 8.6766428 0 15.7098571-6.9796429 15.7098571-15.588 0-8.60935714-7.0332143-15.588-15.7098571-15.588zm7.8115714 21.5078571c-.3695714.9162143-2.041 1.7523572-2.7785 1.7908572-.7367143.0390714-.7577143.571-4.7742857-1.1738572-4.0160715-1.7452857-6.4322857-5.9888571-6.62278574-6.2621428-.19064286-.2722857-1.55571429-2.2176429-1.48207143-4.1753572.07414286-1.95807139 1.14621428-2.8818571 1.52885714-3.26607139.38221433-.38478571.82042853-.45371428 1.08800003-.45807142.3162857-.00514286.5211428-.00942858.7552143-.00078572.2338571.00885714.5851428-.04892857.8892857.75992857.304.80878572 1.0316428 2.79664286 1.1247143 2.99921426.093.2027857.1505714.4375715.0072857.6979286-.1437143.2609286-.2172857.4239286-.4257857.6487857-.2096429.2248572-.441.503-.628.6749286-.2085715.1903571-.4264286.398-.2071429.8049286.2191429.4066428.9752143 1.7397142 2.1270714 2.8382857 1.4803572 1.4122143 2.757 1.8806428 3.1498572 2.0940714.3939285.2145714.629.1907143.8732857-.0663571.2431428-.2570715 1.0456428-1.1247143 1.3282857-1.5120715.2825-.3884285.5472143-.3123571.9101429-.1663571.3627142.1465714 2.2969285 1.1825714 2.6909285 1.3965.3935715.2135.6566429.3235.7507143.4928571.0940714.17.0643572.9665-.3050714 1.8827857z"
        fill="#000"
        fillRule="nonzero"
        transform="translate(188 19)"
      />
    </g>
  </svg>
);

export const InstagramSVG = (props) => (
  <svg height={32} viewBox="0 0 32 32" width={32} {...props}>
    <filter id="a">
      <feColorMatrix in="SourceGraphic" type="matrix" values="0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 1.000000 0"/>
    </filter>
    <linearGradient id="b">
      <stop offset="0" stopColor="#e09b3d"/>
      <stop offset=".3" stopColor="#c74c4d"/>
      <stop offset=".6" stopColor="#c21975"/>
      <stop offset="1" stopColor="#7024c4"/>
    </linearGradient>
    <linearGradient id="c" x1="50%" x2="50%" xlinkHref="#b" y1="99.708911%" y2=".776722%"/>
    <linearGradient id="d" x1="50%" x2="50%" xlinkHref="#b" y1="146.098873%" y2="-45.159683%"/>
    <linearGradient id="e" x1="50%" x2="50%" xlinkHref="#b" y1="658.140556%" y2="-140.029283%"/>
    <g fill="none" fillRule="nonzero" filter="url(#a)" transform="translate(0 .5)">
      <path
        d="m22.4277101 0h-12.91142024c-5.24730435 0-9.51628986 4.26898551-9.51628986 9.51628986v12.91142024c0 5.2473044 4.26898551 9.5162899 9.51628986 9.5162899h12.91142024c5.2473044 0 9.5162899-4.2689855 9.5162899-9.5162899v-12.91142024c0-5.24730435-4.2690435-9.51628986-9.5162899-9.51628986zm6.3027247 22.4277101c0 3.4808696-2.8218551 6.3027247-6.3027247 6.3027247h-12.91142024c-3.48086957 0-6.30272464-2.8218551-6.30272464-6.3027247v-12.91142024c0-3.48092754 2.82185507-6.30272464 6.30272464-6.30272464h12.91142024c3.4808696 0 6.3027247 2.8217971 6.3027247 6.30272464z"
        fill="url(#c)"
      />
      <path
        d="m15.972 7.71014493c-4.5555942 0-8.26185507 3.70626087-8.26185507 8.26179707 0 4.5555363 3.70626087 8.2618551 8.26185507 8.2618551s8.2618551-3.7062609 8.2618551-8.2618551-3.7062609-8.26179707-8.2618551-8.26179707zm0 13.31014497c-2.7881159 0-5.0482899-2.260174-5.0482899-5.0482899s2.2602319-5.0482899 5.0482899-5.0482899c2.7881159 0 5.0482899 2.260174 5.0482899 5.0482899 0 2.788058-2.2602319 5.0482899-5.0482899 5.0482899z"
        fill="url(#d)"
      />
      <circle cx="24.249855" cy="7.772174" fill="url(#e)" r="1.97971"/>
    </g>
  </svg>
);

export const YoutubeSVG = (props) => (
  <svg height={23} viewBox="0 0 32 23" width={32} {...props}>
    <path
      d="m31.340625 3.5517578c-.36875-1.3708984-1.4496094-2.4515625-2.8203125-2.8207031-2.5041016-.68515625-12.5207031-.68515625-12.5207031-.68515625s-10.01621095 0-12.5203125.65917965c-1.34433595.36875-2.4515625 1.4759766-2.8203125 2.8466797-.6589844 2.50390625-.6589844 7.6966797-.6589844 7.6966797s0 5.2189453.6589844 7.6966797c.3691406 1.3707031 1.44960935 2.4513672 2.8205078 2.8205078 2.5302734.6853516 12.5205078.6853516 12.5205078.6853516s10.0162109 0 12.5203125-.6591797c1.3708984-.3689453 2.4515625-1.4496094 2.8207031-2.8203125.6589236-2.5041016.6589236-7.6966797.6589236-7.6966797s.0262327-5.21914065-.6593142-7.7230469zm-18.5300781 12.4939453v-9.5945312l8.3292969 4.7972656z"
      transform="translate(0 .5)"
    />
  </svg>
);

export const LinkedinSVG = (props) => (
  <svg width={27} height={27} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M25 0a2 2 0 012 2v23a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2h23zM8 10H4v13h4V10zm10.475 0l-.25.006c-1.868.09-2.753 1.2-3.257 2.029l-.04.066v-1.806H11l.001.032v.04c.002.026.002.062.003.109l.001.06c.004.268.01.809.013 1.86v.273l.001.144.001.307v.162l.001.615v2.325A2442.91 2442.91 0 0111 23h3.928v-7.09l.005-.228c.012-.301.05-.585.127-.81.286-.757.931-1.539 2.018-1.539 1.42 0 1.994 1.167 1.994 2.872V23H23v-7.282l-.004-.288c-.093-3.7-1.995-5.43-4.521-5.43zM6.01 4C4.8 4 4 4.865 4 6c0 1.111.768 2 1.968 2h.021l.167-.005C7.3 7.919 8.01 7.06 8 6c-.01-1.135-.768-2-1.99-2z"
      fillRule="evenodd"
    />
  </svg>
);

export const StravaSVG = (props) => (
  <svg width={32} height={32} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M30 0a2 2 0 012 2v28a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2h28zM17 19h-3l5 10 5-10h-3l-2 4.286L17 19zM14.694 3.265L7.837 17.633h4.408l2.449-5.945 2.449 5.945h4.408L14.694 3.265z"
      fill="#000"
      fillRule="nonzero"
    />
  </svg>
);
